"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ListItem = require("./ListItem.styles");
var _events = require("../../../../utilities/events");
var _Checkbox = require("../../../../UI/Checkbox");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ListItem = function ListItem(props) {
  var ref = (0, _react.useRef)(null);
  var children = props.children,
    isDisabled = props.isDisabled,
    isSelected = props.isSelected,
    id = props.id,
    _props$role = props.role,
    role = _props$role === void 0 ? 'listitem' : _props$role,
    _props$isFocused = props.isFocused,
    isFocused = _props$isFocused === void 0 ? false : _props$isFocused,
    _props$isWithCheckbox = props.isWithCheckbox,
    isWithCheckbox = _props$isWithCheckbox === void 0 ? false : _props$isWithCheckbox,
    _props$checkboxVertic = props.checkboxVerticalAlign,
    checkboxVerticalAlign = _props$checkboxVertic === void 0 ? 'top' : _props$checkboxVertic,
    color = props.color,
    size = props.size,
    _props$isSeparator = props.isSeparator,
    isSeparator = _props$isSeparator === void 0 ? false : _props$isSeparator,
    onClick = props.onClick,
    onDisabledClick = props.onDisabledClick,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className;
  var styles = (0, _ListItem.useStyles)(props);
  var handleClick = function handleClick(event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    if (isDisabled) {
      if (onDisabledClick) {
        onDisabledClick();
      }
    } else if (onClick) {
      onClick(id);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    (0, _events.handleSpaceOrEnterDown)(event, handleClick);
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        var nextElement = event.target.nextElementSibling;
        while (((_nextElement = nextElement) === null || _nextElement === void 0 ? void 0 : _nextElement.getAttribute('tabIndex')) === '-1') {
          var _nextElement;
          nextElement = nextElement.nextElementSibling;
        }
        if (nextElement) {
          nextElement.focus();
        }
        break;
      case 'ArrowUp':
        event.preventDefault();
        var prevElement = event.target.previousElementSibling;
        while (((_prevElement = prevElement) === null || _prevElement === void 0 ? void 0 : _prevElement.getAttribute('tabIndex')) === '-1') {
          var _prevElement;
          prevElement = prevElement.previousElementSibling;
        }
        if (prevElement) {
          prevElement.focus();
        }
        break;
      default:
        break;
    }
  };
  var handleMouseEnter = function handleMouseEnter(event) {
    if (!isDisabled) {
      if (onMouseEnter) {
        onMouseEnter(event);
      }
    }
  };
  var handleMouseLeave = function handleMouseLeave(event) {
    if (!isDisabled) {
      if (onMouseLeave) {
        onMouseLeave(event);
      }
    }
  };
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      if (isFocused && ref !== null && ref !== void 0 && ref.current) {
        ref === null || ref === void 0 ? void 0 : ref.current.focus();
      }
    }, 0);
  }, [isFocused]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
    className: "".concat(styles['cc-ListItem'], " ").concat(className).trimEnd(),
    ref: ref,
    role: role,
    "data-value": id,
    "data-testid": "ccListItem",
    tabIndex: isDisabled || isSeparator ? -1 : 0,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    "aria-selected": isSelected,
    children: isWithCheckbox ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.Checkbox, {
      id: id,
      isChecked: Boolean(isSelected),
      isDisabled: isDisabled,
      tabIndex: -1,
      verticalAlign: checkboxVerticalAlign,
      color: color,
      size: size,
      label: children,
      onClick: function onClick() {
        return false;
      }
    }) : children
  }, "cc-ListItem--".concat(id));
};
exports.ListItem = ListItem;